import { QUERY_PATH_ORIGIN } from 'modules/queryBuilder/constants';

export const constructWarningPath = (path: (string | number)[], conditionProperty: string) =>
  [QUERY_PATH_ORIGIN, ...path, conditionProperty].join('.');
